import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import cs from 'vuetify/es5/locale/cs'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
library.add(fas) // Include needed icons

const vuetify = new Vuetify({
  lang: {
    locales: { cs },
    current: 'cs'
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        darkGreen: '#409a3f',
        lightGray: '#f9f9fb',
        lightGreen: '#62b95f',
        lightYellow: '#f7ffe8',
        background: '#a70000',
        info: '#409a3f'
      }
    }
  }
})
Vue.use(Vuetify)
Vue.use(
  TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'mdi'
  }
)
Vue.component('my-component', {
  methods: {
    changeLocale () {
      this.$vuetify.lang.current = 'cs'
    }
  }
})

export default vuetify
